import PropTypes from 'prop-types';
// next
import { useRouter } from 'next/router';
// @mui
import { TableRow, TableCell, Typography, Stack, Link, Button } from '@mui/material';
// components
import Avatar from '../../components/Avatar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
// utils
import { fKrDateKST } from '../../utils/formatTime';
//
import { PATH_TODO } from '../../routes/paths';

// ----------------------------------------------------------------------

CrewsTableRow.propTypes = {
  row: PropTypes.object,
};

export default function CrewsTableRow({ row, openProfileDialog }) {
  const {
    id,
    randomhash,
    contract_end_date,
    nickname,
    get_position_display,
    is_active,
  } = row;

  const getStatusColor = (isActive) => {
    return isActive ? 'info' : 'default';
  };

  const router = useRouter();

  const pushToCrew = () => {
    router.push({pathname: PATH_TODO.detail, query: {c: id}})
  }

  return (
    <TableRow>
      <TableCell align="left">
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="left">
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
            alt={nickname}
            sx={{
              width: 40,
              height: 40,
            }}
          />
          {is_active && (
            <Button disableFocusRipple size="medium" onClick={() => openProfileDialog(row)} sx={{ whiteSpace: 'nowrap', fontWeight: 700, lineHeight: 1.5, fontSize: '1rem', textTransform: 'none' }}>
              {nickname}
            </Button>
          )}
          {!is_active && (
            <Typography variant="subtitle1" noWrap sx={{ px: 1, py: 1 }}>
              {nickname}
            </Typography>
          )}
        </Stack>
      </TableCell>

      <TableCell align="center">
        <Label variant="outlined">
          {get_position_display}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Label color={getStatusColor(is_active)}>
          {is_active ? '계약 중' : '계약 종료'}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">
          {fKrDateKST(contract_end_date)}
        </Typography>
      </TableCell>

      <TableCell align="right">
        <Stack direction="row" spacing={.5} alignItems="center" justifyContent="right">
          <Link
            variant="subtitle2" onClick={pushToCrew} 
            underline="hover" color="text.secondary" noWrap
            sx={{ cursor: 'pointer' }}
          >
            크루 상세 기록 보기
          </Link>
          <Iconify icon="eva:chevron-right-fill"
            sx={{ color: "text.secondary",
              ml: 0.5,
              width: 20,
              height: 20,
            }}
          />
        </Stack>
      </TableCell>
    </TableRow>
  )
}